import { Alert, Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, InputAdornment, TextField, Typography } from "@mui/material";
import { InputProduto } from "../..";
import { useState } from "react";
import { TProdutosRessuprimento } from "..";
import PaperDraggable from "../../../../../../components/PaperDraggable";
import { enqueueSnackbar } from "notistack";

export default function DialogEncomendas({ open, handleClose, onChange, selecionado, row, selecionados }: DialogEncomendasProps) {

    const [encomendas, setEncomendas] = useState(selecionado?.encomenda ?? 0)

    const handleChangeEncomenda = (operation: "clean" | "add") => {
        if (operation === "add" && encomendas > (selecionado?.quantidade ?? 0)) {
            enqueueSnackbar("Encomenda não pode ser maior que a quantidade solicitada", { variant: "error" })
            return;
        }

        let newSelecionados: Array<InputProduto> = [...selecionados];
        const params = {
            codigo: row.codigo,
            nome: row.nome,
            quantidade: selecionado?.quantidade ?? 0,
            encomenda: operation === "clean" ? null : encomendas,
            departamento: row.departamento,
            setor: row.setor
        }

        let index = newSelecionados.findIndex((i) => i.codigo === row.codigo);

        if (index === -1) newSelecionados.push(params)
        if (index !== -1) newSelecionados[index] = params

        onChange(newSelecionados);
        handleClose();
    }

    return (

        <Dialog
            fullWidth
            maxWidth="xs"
            open={open}
            onClose={handleClose}
            PaperComponent={PaperDraggable}
            aria-labelledby="draggable-dialog-title"
            scroll="body"
        >
            <DialogTitle style={{ cursor: 'move' }} id="draggable-dialog-title">Marcar como encomenda</DialogTitle>

            <DialogContent>
                <Alert severity="info" icon={false}>
                    <Typography variant="subtitle1">{selecionado?.nome}</Typography>
                </Alert>

                <Box display="flex" justifyContent="space-between" alignItems="center">
                    <Typography variant="subtitle2">Qtd. Solicitada: <b>{selecionado?.quantidade} {row.unidade_medida}</b></Typography>

                    <TextField
                        margin="normal"
                        size="small"
                        variant="outlined"
                        label="Encomenda"
                        value={encomendas}
                        error={selecionado && selecionado.quantidade <= 0 ? true : false}
                        onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                            setEncomendas(Number(event.target.value))
                        }}
                        slotProps={{
                            input: { endAdornment: <InputAdornment position="end">{row.unidade_medida}</InputAdornment> }
                        }}
                        sx={{
                            maxWidth: 140
                        }}
                    />
                </Box>
            </DialogContent>

            <DialogActions>
                <Button
                    variant="text"
                    onClick={() => handleChangeEncomenda("clean")}
                >
                    Limpar
                </Button>
                <Button
                    variant="contained"
                    onClick={() => handleChangeEncomenda("add")}
                >
                    Confirmar
                </Button>
            </DialogActions>
        </Dialog>
    )
}

interface DialogEncomendasProps {
    open: boolean;
    row: TProdutosRessuprimento;
    selecionados: InputProduto[];
    selecionado: InputProduto | null;
    handleClose: () => void;
    onChange: (produtos: Array<InputProduto>) => void;
}